import { Controller } from "@api/config";
import type { IRequestConfig } from "@api/config";

import type { TGetVerificationInfoResponse } from "./response.types";

class VerificationController extends Controller {
	public constructor() {
		super({ requestUrl: "models/verification/" });
	}

	/**@GET VERIFICATION INFO */
	public async getVerificationInfoAsync({ token }: IRequestConfig) {
		return this.get<TGetVerificationInfoResponse>("base", "info", { token });
	}

	/**@POST START VERIFICATION */
	public async startVerificationAsync({ token }: IRequestConfig) {
		return this.post<void>("start", null, { token });
	}
}

export const verificationAPI = new VerificationController();
